import { jsx as _jsx } from "react/jsx-runtime";
import { RangeCalendar as HeroRangeCalendar } from '@heroui/react';
export const RangeCalendar = (props) => {
    return _jsx(HeroRangeCalendar, { ...props });
};
export default RangeCalendar;
//# sourceMappingURL=RangeCalendar.js.map